<template>
  <div class="account-form-wrapper" :class="{ 'two-rows': showUpdateButton }">
    <section
      v-if="!showUpdateButton"
      aria-label="Account name"
      class="name-section mt-2"
    >
      <div
        v-for="(value, key) in filteredFormFields"
        :key="key"
        class="flex-grow-1 account-form-field"
      >
        <div
          class="account-read-only-field"
        >
          <p class="form-label-text mt-1 mb-1">
            {{ form.labels[key] }}
          </p>
          <p class="text-body-1 text-textDarkest mb-0 mt-2">
            {{ value }}
          </p>
        </div>
      </div>
    </section>
    <v-form
      v-else
      class="name-form"
      @submit.prevent="$emit('submit')"
    >
      <div
        v-for="(value, key) in filteredFormFields"
        :key="key"
        class="flex-grow-1 account-form-field"
      >
        <DpplFormField
          :field-name="key"
          :form="form"
          v-bind="$attrs"
        >
          <template #field="{ props, on }">
            <DpplTextField
              :label="form.labels[key]"
              v-bind="props"
              v-on="on"
            />
          </template>
        </DpplFormField>
      </div>
      <div class="mt-auto">
        <DpplAutoSizedButton
          :disabled="!isValid"
          type="submit"
          @click="$emit('submit')"
        >
          Update
        </DpplAutoSizedButton>
      </div>
    </v-form>
    <section class="email-persona mt-2" aria-label="Email and persona">
      <div class="account-read-only-field mr-12 email-field">
        <p class="form-label-text mt-1 mb-1">
          {{ form.labels.email }}
        </p>
        <p class="text-body-1 text-textDarkest mb-0 mt-2">
          {{ form.values.email }}
        </p>
      </div>
      <AccountEditPersona class="persona-field" />
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplFormField from '@/components/datapeople/DpplFormField.vue';
import AccountEditPersona from '@/components/settings/account/AccountEditPersona.vue';

const props = defineProps({
  form: { type: Object, default: () => ({}) },
  isValid: { type: Boolean, default: false },
  showUpdateButton: { type: Boolean, default: false },
});

defineEmits(['submit']);

const filteredFormFields = computed(() => {
  const { email, ...fullName } = props.form.values;
  return fullName;
});
</script>

<style scoped lang="less">
.account-form-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;

  .email-persona {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .name-section {
    display: grid;
    grid-template-columns: repeat(2, auto);
  }

  .name-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)) 88px;
  }

  &.two-rows {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);

    .email-persona {
      grid-template-columns: repeat(2, minmax(0, 1fr)) 88px;

      .email-field {
        grid-column: 1 / 2;
      }
      .persona-field {
        grid-column: 2 / 3;
      }
    }
  }
}

:deep(.v-input) {
  color: @text-lighter;
}

:deep(.v-field--disabled) {
  opacity: 1;
}

.account-form-field {
  flex: 1;

  &:not(:last-child) {
    margin-right: 24px;
  }
}
</style>
